/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { CommonKeyCombinations } from "../../common/KeyCombinations";
import { IEditor } from "../../IEditor";

export function registerKeyBindings(dc: IEditor): void {
	const viewSvc = dc.get("viewService");
	const keyBindingSvc = dc.get("keyBindingService");

	keyBindingSvc.register({
		id: "configEditor.edit.save",
		label: "Save",
		commandId: "configEditor.edit.save",
		keys: CommonKeyCombinations.save,
		when: () => viewSvc.isViewActive("appConfig")
	});

	keyBindingSvc.register({
		id: "configEditor.edit.undo",
		label: "Undo",
		commandId: "configEditor.edit.undo",
		keys: CommonKeyCombinations.undo,
		when: () => viewSvc.isViewActive("appConfig")
	});

	keyBindingSvc.register({
		id: "configEditor.edit.redo",
		label: "Redo",
		commandId: "configEditor.edit.redo",
		keys: CommonKeyCombinations.redo,
		when: () => viewSvc.isViewActive("appConfig")
	});
}
